/**
 * Isometric coordinate system.
 * Standard 2:1 diamond projection (64x32 tiles).
 */

export const TILE_WIDTH = 64;
export const TILE_HEIGHT = 32;

export interface ScreenPoint {
  x: number;
  y: number;
}

export interface WorldPoint {
  x: number;
  y: number;
}

/** Convert world (tile) coordinates to screen (pixel) coordinates. */
export function worldToScreen(wx: number, wy: number): ScreenPoint {
  return {
    x: (wx - wy) * (TILE_WIDTH / 2),
    y: (wx + wy) * (TILE_HEIGHT / 2),
  };
}

/** Convert screen (pixel) coordinates to world (tile) coordinates. */
export function screenToWorld(sx: number, sy: number): WorldPoint {
  return {
    x: (sx / (TILE_WIDTH / 2) + sy / (TILE_HEIGHT / 2)) / 2,
    y: (sy / (TILE_HEIGHT / 2) - sx / (TILE_WIDTH / 2)) / 2,
  };
}

/** Snap a world coordinate to the nearest tile center. */
export function snapToTile(wx: number, wy: number): WorldPoint {
  return {
    x: Math.round(wx),
    y: Math.round(wy),
  };
}

/** Calculate depth sort key for correct draw ordering. */
export function depthSortKey(wx: number, wy: number, zLayer: number = 0): number {
  return wy + wx * 0.001 + zLayer * 1000;
}
